<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <merchant-all-set />
      </div>
    </div>
    <!--<div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div>-->
  </div>
</template>

<script>
import MerchantAllSet from "./MerchantAllSet";
//import ProjectsTable from "../components/ProjectsTable";

export default {
  name: "tables",
  components: {
    MerchantAllSet,
    //ProjectsTable,
  },
};
</script>
